import { actionCopyFr } from "./actionCopy";

export const formPageCopyFr = {
    entryFor: (label) => `Saisie pour ${label}`,
    next: actionCopyFr.next,
    back: actionCopyFr.back,
    changingAnswers: "Vous modifiez des réponses déjà données",
    submit: actionCopyFr.submit,
    startNow: "Commencer maintenant",
    startForm: "Commencer le formulaire",
    startingForm: "Démarrage du formulaire...",
    formSubmitted: "Formulaire envoyé",
    errorsOnPage: (count) =>
        count === 1 ? "Erreur sur 1 question de cette page" : `Erreurs sur ${count} questions de cette page`,
    invalidValue: "Valeur non valide",
    groupTotal: (total, target) => `Total : ${total} sur ${target}`,
    groupMustTotal: (target) => `Ces réponses doivent totaliser ${target}`,
    groupPlaced: (total, target) => `${total} sur ${target} répartis`,
    groupLeft: (n) => `${n} restant${n > 1 ? "s" : ""}`,
    groupOver: (n) => `${n} en trop`,
    groupComplete: (target) => `Les ${target} sont répartis`,
    countIncrease: (label) => `Ajouter un à ${label}`,
    countDecrease: (label) => `Retirer un de ${label}`,
    countRequired: "Saisissez un nombre, ou 0 si aucun",
    answerTooHigh: "Ce nombre ne peut pas dépasser votre réponse précédente",
    exclusiveConflict: "Cette réponse ne peut pas être combinée avec les autres réponses",
    tickAtLeastOne: "Veuillez cocher au moins une réponse",
    pageOf: (page, total) => `Page ${page} sur ${total}`,
    carriedNote: "Nous avons repris ceci de la dernière fois.",
    yes: "Oui",
    no: "Non",
    ownOptionOther: "Autre",
    ownOptionPlaceholder: "Saisissez votre réponse",
    ownOptionAdd: "Ajouter",
    ownOptionSave: "Enregistrer",
    ownOptionCancel: "Annuler",
    ownOptionEdit: (label) => `Modifier « ${label} »`,
    ownOptionDelete: (label) => `Supprimer « ${label} »`,
    ownOptionInUse:
        "Vous avez déjà utilisé cette réponse, elle ne peut donc pas être supprimée. Vous pouvez la renommer.",
    ownOptionEmpty: "Veuillez saisir votre réponse",
    ownOptionTooLong: "Veuillez utiliser 100 caractères au maximum",
    ownOptionLimit: "Vous pouvez ajouter jusqu'à 20 réponses personnelles",
    ownOptionFailed: "Nous n'avons pas pu l'enregistrer. Veuillez réessayer.",
    questionOf: (current, total) => `Question ${current} sur ${total}`,
    questionsRange: (min, max) => `Questions ${min} à ${max}`,
    questionsRangeOf: (min, max, total) => `Questions ${min} à ${max} sur ${total}`,
    formatProgressLabel: ({ min, max, total, pageNumber, pageTotal }) => {
        let questionPart: string;
        if (min === max) {
            questionPart = `Question ${min} sur ${total}`;
        } else if (max === total) {
            questionPart = `Questions ${min} à ${max}`;
        } else {
            questionPart = `Questions ${min} à ${max} sur ${total}`;
        }

        if (min === max && min === pageNumber && pageTotal === total) {
            return questionPart;
        }

        return `Page ${pageNumber} sur ${pageTotal} - ${questionPart}`;
    },
};
